import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

function DiscordAuthHandler() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const authStatus = searchParams.get("auth");
    const error = searchParams.get("error");
    // 💡 CRITICAL: Read the path provided by the Flask backend
    const finalPath = searchParams.get("path");

    let redirectPath = "/"; // Default error fallback
    let statusMessage = "Processing Discord callback...";

    if (error) {
      statusMessage = `Authentication Failed: ${error}. Redirecting to login.`;
      // redirectPath remains "/"
    } else if (authStatus === "success" && finalPath) {
      statusMessage =
        "Authentication successful. Redirecting to your dashboard...";
      // 💡 Use the definitive path provided by the backend
      redirectPath = finalPath;
    } else {
      // Fallback for an unrecognized success state or missing path
      statusMessage = "Authentication complete. Checking default route...";
      redirectPath = "/onboarding";
    }

    // Navigate to a dedicated visual loading route, passing the final destination
    navigate("/loading", {
      replace: true,
      state: {
        message: statusMessage,
        redirectTo: redirectPath, // This is the final destination (/dashboard or /onboarding)
      },
    });
  }, [navigate, searchParams]);

  return (
    <div
      style={{
        backgroundColor: "#121212",
        minHeight: "100vh",
        width: "100vw",
      }}
    />
  );
}

export default DiscordAuthHandler;
